import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const MemberTableHeader = ({ 
  sortConfig, 
  onSort, 
  allSelected, 
  onSelectAll,
  totalMembers,
  selectedCount 
}) => {
  const getSortIcon = (column) => {
    if (sortConfig?.key !== column) {
      return <Icon name="ArrowUpDown" size={14} className="text-muted-foreground" />;
    }
    return sortConfig?.direction === 'asc' 
      ? <Icon name="ArrowUp" size={14} className="text-primary" />
      : <Icon name="ArrowDown" size={14} className="text-primary" />;
  };

  const handleSort = (column) => {
    const direction = sortConfig?.key === column && sortConfig?.direction === 'asc' ? 'desc' : 'asc';
    onSort({ key: column, direction });
  };

  const columns = [
    { key: 'name', label: 'Member', sortable: true },
    { key: 'cpf', label: 'CPF', sortable: true },
    { key: 'voterId', label: 'Voter ID', sortable: true },
    { key: 'region', label: 'Region', sortable: true },
    { key: 'registrationDate', label: 'Registration Date', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'actions', label: 'Actions', sortable: false }
  ];

  return (
    <thead className="bg-muted/50">
      <tr>
        <th className="px-4 py-3 text-left">
          <Checkbox
            checked={allSelected}
            onChange={(e) => onSelectAll(e?.target?.checked)}
            indeterminate={selectedCount > 0 && !allSelected}
          />
        </th>
        {columns?.map((column) => (
          <th key={column?.key} className="px-4 py-3 text-left">
            {column?.sortable ? (
              <button
                onClick={() => handleSort(column?.key)}
                className="flex items-center space-x-2 text-sm font-medium text-foreground hover:text-primary transition-colors duration-200 group"
              >
                <span>{column?.label}</span>
                <div className="group-hover:opacity-100 opacity-60 transition-opacity duration-200">
                  {getSortIcon(column?.key)}
                </div>
              </button>
            ) : (
              <span className="text-sm font-medium text-foreground">{column?.label}</span>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default MemberTableHeader;